import { CreditCardSettings } from './types';

const commonSettings = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'gray.light',
};

export const creditCardSettings: CreditCardSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        regular: {
          width: '320px',
          height: '180px',
          borderRadius: 3,
          padding: 6,
          ...commonSettings,
        },
        small: {
          width: '250px',
          height: '140px',
          borderRadius: 3,
          padding: 4,
          ...commonSettings,
        },
      },
    },
    variant: {
      prop: 'variant',
      variants: {
        primary: {
          background: (props) =>
            `radial-gradient(56.87% 164.82% at 86.8% 24.4%, rgba(255, 255, 255, 0.3) 0%, rgba(154, 196, 225, 0.3) 100%), ${props.colors.primary.extraLight};`,
        },
        secondary: {
          background: (props) =>
            `radial-gradient(56.87% 164.82% at 86.8% 24.4%, rgba(255, 255, 255, 0.3) 0%, rgba(189, 197, 202, 0.3) 100%), ${props.colors.primary.extraLight};`,
        },
      },
    },
    status: {
      prop: 'status',
      variants: {
        active: {
          borderColor: 'success.main',
        },
        error: {
          borderColor: 'danger.main',
        },
        unavailable: {
          borderColor: 'danger.main',
          opacity: 0.65,
        },
        normal: {},
      },
    },
  },
};
